export default "__VITE_ASSET__CnkPaDED__"